import i18n from 'shared/lib/i18n';

export const buildingTypes = () => [
  {
    id: 'condo',
    name: i18n.t('buildingTypes.condo'),
  },
  {
    id: 'rental',
    name: i18n.t('buildingTypes.rental'),
  },
];

export const cameraSystems = () => [
  {
    id: 'eagle_eye',
    name: i18n.t('provider.eagleEye'),
  },
  {
    id: 'bmx',
    name: i18n.t('provider.bmx'),
  },
];

export const paymentSystems = () => [
  {
    id: 'clickpay',
    name: i18n.t('provider.clickpay'),
  },
  {
    id: 'aptexx',
    name: i18n.t('provider.aptexx'),
  },
];

export const getServiceRequestStatuses = () => [
  {
    id: 'opened',
    name: i18n.t('actions.open'),
  },
  {
    id: 'in_progress',
    name: i18n.t('callStatuses.inProgress'),
  },
  {
    id: 'resolved',
    name: i18n.t('status.resolved'),
  },
  {
    id: 'cancelled',
    name: i18n.t('status.canceled'),
  },
];

export const limitOptions = () => [
  {
    id: 25,
    name: i18n.t('pagination.25'),
  },
  {
    id: 50,
    name: i18n.t('pagination.50'),
  },
  {
    id: 100,
    name: i18n.t('pagination.100'),
  },
  {
    id: 200,
    name: i18n.t('pagination.200'),
  },
];

export const paginationOptions = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];

export const DATE_RANGES_TYPES = {
  created: 'created',
  created_at: 'created_at',
  created_date: 'created_date',
  updated_at: 'updated_at',
  latest_call_time: 'latest_call_time',
  valid_until: 'valid_until',
  last_activity_time: 'last_activity_time',
  effective_date: 'effective_date',
  date: 'date',
  starts: 'starts',
};

export const TABLE_DATA_TYPES = {
  accessPoints: (count) => i18n.t('tableDataTypes.access-point', { count }),
  carsonActivity: (count) => i18n.t('tableDataTypes.action-record', { count }),
  personActionsLog: (count) =>
    i18n.t('tableDataTypes.person-action-record', { count }),
  buildings: (count) => i18n.t('tableDataTypes.building', { count }),
  doorsOpeningLog: (count) =>
    i18n.t('tableDataTypes.door-opening-log-record', { count }),
  deliveries: (count) => i18n.t('tableDataTypes.delivery', { count }),
  items: (count) => i18n.t('tableDataTypes.item', { count }),
  posts: (count) => i18n.t('tableDataTypes.post', { count }),
  comments: (count) => i18n.t('tableDataTypes.comment', { count }),
  pendingApprovalComments: (count) =>
    i18n.t('tableDataTypes.pending-approval-comment', { count }),
  person: (count) => i18n.t('tableDataTypes.person', { count }),
  serviceRequests: (count) =>
    i18n.t('tableDataTypes.service-request', { count }),
  visitors: (count) => i18n.t('tableDataTypes.person-record', { count }),
  visitorsLog: (count) => i18n.t('tableDataTypes.entry-record', { count }),
  ip: (count) => i18n.t('tableDataTypes.ip', { count }),
  pmcs: (count) => i18n.t('tableDataTypes.pmc', { count }),
  doors: (count) => i18n.t('tableDataTypes.door', { count }),
  cameras: (count) => i18n.t('tableDataTypes.camera', { count }),
  units: (count) => i18n.t('tableDataTypes.unit', { count }),
  types: (count) => i18n.t('tableDataTypes.type', { count }),
  accessCards: (count) => i18n.t('tableDataTypes.access-card', { count }),
  accessCardBatches: (count) =>
    i18n.t('tableDataTypes.access-card-batch', { count }),
  callRecords: (count) => i18n.t('tableDataTypes.call-record', { count }),
  events: (count) => i18n.t('tableDataTypes.event', { count }),
};

export const timeOnlyFormat = 'hh:mm:ss';
export const dateOnlyFormat = 'MM/DD/YY';
export const defaultDateFormat = 'MM/DD/YY hh:mm a';
export const fullTimeDateFormat = 'MM/DD/YY hh:mm:ss';
export const fullTimeDateFormat24 = 'MM/DD/YY HH:mm:ss';

export const drawerClosedWidth = 75;
export const drawerOpenedWidth = 272;

export const LOADABLE_DELAY = 600;
export const LOADABLE_TIME_OUT = 10000;
export const INACTIVITY_LOG_OUT_TIME = 7200000;
export const INACTIVITY_COUNT_DOWN_TIME = 30000;
export const IMPORT_LIMIT = 3;
export const IMPORT_DELAY = 1000;

export const BMX_LOGGER = true;
